import 'filepond/dist/filepond.min.css'

import { FilePond } from 'react-filepond'
import { useDispatch } from 'react-redux'

import apiSlice from '../../services/api/slice'

function FileUploader({ name, files, setFiles, signedUrlMutation, trigger, invalidateTags }) {
  const dispatch = useDispatch()

  return (
    <FilePond
      name={name}
      files={files}
      onupdatefiles={setFiles}
      allowRevert={false}
      allowMultiple={false}
      credits={false}
      labelIdle="Select or drag and drop a file"
      server={{
        process: (fieldName, file, metadata, load, error, progress, abort) => {
          signedUrlMutation({ payload: { filename: file.name } }).then(({ data: response, error: err }) => {
            if (response) {
              const request = new XMLHttpRequest()
              request.open('PUT', response.url)

              request.upload.onprogress = (event) => {
                progress(event.lengthComputable, event.loaded, event.total)
              }

              request.onload = () => {
                if (request.status >= 200 && request.status < 300) {
                  load(request.responseText)
                } else {
                  request.abort()
                  abort()
                }
              }

              request.send(file)

              return {
                abort: () => {
                  request.abort()
                  abort()
                },
              }
            }
            error(err.message)
            return undefined
          })
        },
      }}
      onwarning={() => trigger(false)}
      onerror={() => trigger(false)}
      onaddfilestart={() => trigger(true)}
      onprocessfiles={async () => {
        trigger(false)
        if (invalidateTags) {
          setTimeout(() => {
            dispatch(apiSlice.util.invalidateTags(invalidateTags))
          }, 5000)
        }
      }}
    />
  )
}

export default FileUploader
